import React from 'react';

import { Button } from 'components/Buttons/Button';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import { ButtonType } from 'enums/ButtonType';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';
import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'hooks/useAppSelector';
import { AppRoutes } from 'routes/routes.enums';

import styles from './AcknowledgementAndConsent.module.scss';

const AcknowledgementAndConsent = () => {
  const navigator = useAppNavigate();
  const { [LoanInformationVariables.LoanAmount]: loanAmount } = useAppSelector((state) => state.application);

  const handleBack = () => {
    navigator(AppRoutes.Prequalification);
  };

  return (
    <>
      <FormHeader title="Acknowledgement and Consent" />
      <FormBody>
        <p className={styles.bodyText}>
          You understand that by accepting the "Terms of Use" and clicking the "I Agree/ Submit" button in the inquiry,
          you certify that all of the information provided in this application is true and correct, and you are
          confirming you have read and understand the Privacy Policy and Application Disclosure, and you are providing
          written instructions to this company under the Fair Credit Reporting Act authorizing this company to obtain
          information from your personal credit profile or other information from Experian and/or TransUnion and/or
          Equifax, to confirm your identity to avoid fraudulent transactions in your name.
        </p>
      </FormBody>
      {loanAmount && (
        <div className={styles.buttonContainer}>
          <Button onClick={handleBack} buttonType={ButtonType.Secondary} withArrow>
            Back
          </Button>
        </div>
      )}
    </>
  );
};

export default AcknowledgementAndConsent;
